"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERRAL_STATUS = void 0;
var REFERRAL_STATUS;
(function (REFERRAL_STATUS) {
    REFERRAL_STATUS["DECLINED"] = "DECLINED";
    REFERRAL_STATUS["ACCEPTED"] = "ACCEPTED";
})(REFERRAL_STATUS || (exports.REFERRAL_STATUS = REFERRAL_STATUS = {}));
